import moment from 'moment';
class DateHandler {
    constructor() {
        moment.updateLocale("en", { week: {
                dow: 1,
                doy: 4, // First week of year must contain 4 January (7 + 1 - 4)
            } });
    }
    getCurrentMonthNoDay(date) {
        return moment(date).format('YYYY-MM');
    }
    addHours(date, inputNumber) {
        return moment.utc(date).add(inputNumber, "hours").format();
    }
    addDays(date, inputNumber) {
        return moment(date).add(inputNumber, "days").format('YYYY-MM-DD');
    }
    subtractDays(date, inputNumber) {
        return moment(date).subtract(inputNumber, "days").format('YYYY-MM-DD');
    }
    addMonths(date, inputNumber) {
        return moment(date).add(inputNumber, "months");
    }
    subtractMonths(date, inputNumber) {
        return moment(date).subtract(inputNumber, "months");
    }
    addWeeks(date, inputNumber) {
        return moment(date).add(inputNumber, "weeks").format('YYYY-MM-DD');
    }
    subtractWeeks(date, inputNumber) {
        return moment(date).subtract(inputNumber, "weeks").format('YYYY-MM-DD');
    }
    getMondayFromDate(date) {
        return moment(date).startOf("isoWeek").format('YYYY-MM-DD');
    }
    getSundayFromDate(date) {
        return moment(date).endOf("isoWeek").format('YYYY-MM-DD');
    }
    getMondayFromWeekNumber(week) {
        return moment().isoWeek(week).startOf("isoWeek").format('YYYY-MM-DD');
    }
    getSundayFromWeekNumber(week) {
        return moment().isoWeek(week).endOf("isoWeek").format('YYYY-MM-DD');
    }
    getStartOfMonth(date) {
        return moment(date).startOf("month");
    }
    getStartOfYear(date) {
        return moment(date).startOf("year");
    }
    getEndOfMonth(date) {
        return moment(date).endOf("month");
    }
    getNumberOfDaysInMonth(date) {
        return moment(date).daysInMonth();
    }
    getDayOfWeekAsNumber(date) {
        return moment(date).isoWeekday();
    }
    isDateWeekend(date) {
        return (moment(date).isoWeekday() === 6 || moment(date).isoWeekday() === 7);
    }
    getYear(date) {
        return moment(date).year();
    }
    convertToUTCTime(date) {
        if (date === null || date === undefined)
            return null;
        return moment.utc(date).format();
    }
    formatDateNoTime(date) {
        return moment.utc(date).format('YYYY-MM-DD');
    }
    getMonthNumber(date) {
        return moment(date).month() + 1; // add one since moment things 0 is jan
    }
    getWeekNumber(date) {
        return moment(date).isoWeek();
    }
    getDayOfMonth(date) {
        return moment(date).date();
    }
    isLastWeekOfYear(date) {
        return moment(date).isoWeek() === moment(date).endOf("year").isoWeek();
    }
    isDateBefore(date1, date2) {
        return moment(date1).format("YYY-MM-DD") < moment(date2).format("YYY-MM-DD");
    }
    currentWeekContainsDate(selectedDate, checkDate) {
        const startWeek = moment(selectedDate).startOf('isoWeek').format("MM-DD");
        const endWeek = moment(selectedDate).endOf('isoWeek').format("MM-DD");
        const tempDate = moment(checkDate).format("MM-DD");
        if (tempDate >= startWeek && tempDate <= endWeek) {
            return true;
        }
        else {
            return false;
        }
    }
    areDatesInSameYear(date1, date2) {
        return moment(date1).format("YYYY") === moment(date2).format("YYYY");
    }
    areDatesInSameMonth(date1, date2) {
        return moment(date1).format("MM") === moment(date2).format("MM");
    }
    daysInMonth(date) {
        return moment(date).daysInMonth();
    }
    daysBetweenDates(startDate, endDate) {
        const start = moment(startDate);
        const end = moment(endDate);
        return end.diff(start, 'days') + 1;
    }
}
export default DateHandler;
